import Program from 'wwg-utilities/dist/collections/program';
import apiClient from './axiosClient';
import GetProgramsDTO from '../dtos/get-programs.dto';

const getProgramsRequest = async (
  params: GetProgramsDTO = {},
): Promise<Program[]> => {
  return apiClient.get(`programs`, { params }).then((res) => res.data);
};

export default getProgramsRequest;
